<template>
  <div class="pt-md-5 pt-2">
    <div class="row">
      <div class="col-12 p-md-0">
        <div class="section-title">{{ currentSection.name }}</div>
        <hr class="hr-container" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-10">
        <div class="row mt-3">
          <div
            class="col-md-6 pt-3 p-md-0 pr-md-3 pb-md-3"
            v-for="child in cardsBySectionId(currentSection.id)"
            :key="child.id"
          >
            <div class="row">
              <div class="col-12">
                <div
                  class="card"
                  style="border: 1px solid #000 !important; height: 230px"
                >
                  <div class="card-body">
                    <div
                      class="
                        card-title
                        custom-card-title-container custom-card-title
                      "
                    >
                      {{ child.name }}
                    </div>
                    <div
                      class="card-text info-container"
                      v-html="child.description"
                    ></div>
                    <get-started class="pt-4" :cardId="child.id"></get-started>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 p-md-0 pt-4 pl-4 pt-md-2">
        <div class="row">
          <div
            class="offset-md-2 col-md-10 p-md-0"
            v-for="child in currentSubSections"
            :key="child.id"
          >
            <div>
              <div class="custom-card-title">{{ child.name }}</div>
              <ul class="child-list">
                <li
                  class="pt-1 pb-3"
                  v-for="resource in child.resources"
                  :key="resource.id"
                >
                  <a target="_blank"
                    class="side-section-lnk"
                    @click="trackSideSectionLink(child.name, resource)"
                    :href="resource.value"
                    >{{ resource.title }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetStarted from "@/components/homepage/GetStarted";
import CardHelperMixin from "@/components/homepage/mixins/CardHelperMixin";
import MixpanelMixin from "@/mixins/MixpanelMixin";

export default {
  mixins: [CardHelperMixin, MixpanelMixin],
  methods: {
    trackSideSectionLink(sectionName, resource) {
      this.trackFeatureSelected(sectionName, resource.title, resource.value);
    },
  },

  components: {
    GetStarted,
  },
};
</script>
<style scoped>
</style>

<style>
.card-body {
  padding: 0.75rem !important;
  width: 100%;
}
.custom-card-title {
  font-size: 18px;
  font-weight: 700;
  font-family: artifaktElementBold;
}
.custom-card-title-container {
  height: 50px;
}

.child-list {
  list-style-type: none;
  padding-inline-start: 0;
}

.side-section-lnk {
  text-decoration: underline;
  color: #666;
  font-size: 16px;
}
.side-section-lnk:hover {
  color: #666;
  text-decoration: underline;
}

.hr-container {
  border-top: 3px solid #000 !important;
}

.info-container {
  max-height: 75px;
  min-height: 75px;
  margin-bottom: 10px;
  overflow: hidden;
}
</style>